var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center flex-column p-5"},[_c('h3',{staticClass:"mb-4"},[_vm._v("You have been signed out.")]),_c('div',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.errorMessage))]),_c('b-button',{on:{"click":_vm.refresh}},[_vm._v("Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }